import React, { useEffect, useReducer } from 'react';
import { Row, Col, Table, Container } from 'react-bootstrap';
import { Currency } from '../lib/components/Currency';
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from '../lib/components/LoadingSpinner';
import { FormattedDate } from '../lib/components/FormattedDate';
import { withHeaderMessages } from '../higherOrderComponents/WithHeaderMessages';
import spinner from '../static/images/spinner.gif';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import './clearpoint-reports.css';

const CombinedDetailsPrint = (props) => {

    const location = useLocation();

    const {
        n
    } = qs.parse(location.search, { ignoreQueryPrefix: true });

    const initialState = {
        isLoading: true,
        contracts: [],
        payoffsAll: [],
        disbursementPayoutsAll: [],
        disbursementPayoutsLoading: true,
        payoffLoading: true,
        contractsQueryString: n
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'contracts':
                return {
                    ...state,
                    contracts: action.payload,
                    isLoading: false
                }
            case 'payoffsAll':
                return {
                    ...state,
                    payoffsAll: action.payload,
                    payoffsLoading: false
                }
            case 'disbursementPayoutsAll':
                return {
                    ...state,
                    disbursementPayoutsAll: action.payload,
                    disbursementPayoutsLoading: false

                }
            case 'contractsQueryString':
                return {
                    ...state,
                    contractsQueryString: action.payload,
                }
            case 'isLoading':
                return {
                    ...state,
                    isLoading: action.payload
                }
            case 'hideLoader': 
                return {
                    ...state,
                    isLoading: false
                }
            default:
                throw new Error();
        }
    }

    const [combinedDetailsState, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const { contractsQueryString } = combinedDetailsState;
        props.header.setHeader("combinedDetails");
        const contractNumbers = contractsQueryString.split(",") || [];
        
        Promise.all(
            contractNumbers.map(n => 
                props.api.get(`/api/contract/${n}`)
                    .then(response => {
                        if (response.status === 200) { 
                            return response.data;
                        }
                    })
            )
        )
        .catch(() => dispatch({ type: 'isLoading', payload: false }))
        .then(contracts => {
            dispatch({ type: 'contracts', payload: contracts });
            dispatch({ type: 'isLoading', payload: false });
        });
    }, [])

    useEffect(() => {
        const { contractsQueryString } = combinedDetailsState;
        const contractNumbers = contractsQueryString.split(",") || [];

        Promise.all(
            contractNumbers.map(n => 
                props.api.get(`/api/contract/${n}/disbursement-payouts`)
                    .then(response => {
                        if (response.status === 200) { 
                            return response.data;
                        }
                    })
            )
        )
        .catch(() => dispatch({ type: 'disbursementPayoutsLoading', payload: false }))
        .then(disbursementPayouts => {
            dispatch({ type: 'disbursementPayoutsAll', payload: disbursementPayouts.flatMap(p => p)});
        });
    }, [])

    const hideLoader = () => {
        dispatch({ type:'isLoading' });
    }


    const renderDisbursementsHeader = () => {
        return (
            <thead>
                <tr>
                    <th style={{fontWeight: "bold"}}>Provider Contract #</th>
                    <th style={{fontWeight: "bold"}}>ClearPoint Contract #</th>
                    <th style={{fontWeight: "bold"}}>Who Was Paid</th>
                    <th style={{fontWeight: "bold"}}>Payout Date</th>
                    <th style={{fontWeight: "bold"}}>Pmt Method</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Principal</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Income</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Total</th>
                </tr>
            </thead>
        )
    }

    const renderDisbursementsDetails = (p) => {
        return (
            <tr>
                <td>{p.providerNumber}</td>
                <td>{p.contractNumber}</td>
                <td>{p.paidTo !== 'Unknown' ? p.paidTo : ''} {p.paidTo !== 'Provider' ? p.paidToName : ''}</td>
                <td><FormattedDate date={p.posted} /></td>
                <td>{p.payoutMethod}</td>
                <td style={{textAlign: "right"}}><Currency amount={p.principal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.income} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.income + p.principal} /></td>
            </tr>
        )
    }

    const renderDisbursementsFooter = (payouts) => {
        const principalTotal = payouts.map(p => p.principal).reduce((a, b) => a + b, 0);
        const incomeTotal = payouts.map(p => p.income).reduce((a, b) => a + b, 0);
        const totalTotal = payouts.map(p => p.income + p.principal).reduce((a, b) => a + b, 0);
        return (
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{textAlign: "right"}}>Total</td>
                <td style={{textAlign: "right"}}><Currency amount={principalTotal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={incomeTotal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={totalTotal} /></td>
            </tr>
        )
    }

    const renderDisbursementsHeaderWithGuaranteed = () => {
        return (
            <thead>
                <tr>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold", textAlign: "center"}} colSpan='2'>Guaranteed</th>
                    <th style={{fontWeight: "bold", textAlign: "center"}} colSpan='2'>Non-Guaranteed</th>
                    <th style={{fontWeight: "bold"}}></th>
                </tr>
                <tr>
                    <th style={{fontWeight: "bold"}}>Provider Contract #</th>
                    <th style={{fontWeight: "bold"}}>ClearPoint Contract #</th>
                    <th style={{fontWeight: "bold"}}>Who Was Paid</th>
                    <th style={{fontWeight: "bold"}}>Payout Date</th>
                    <th style={{fontWeight: "bold"}}>Pmt Method</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Principal</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Income</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Total</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Principal</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Income</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Principal</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Income</th>
                    <th style={{fontWeight: "bold", textAlign: "right"}}>Total</th>
                </tr>
            </thead>
        )
    }

    const renderDisbursementsDetailsWithGuaranteed = (p) => {
        return (
            <tr>
                <td>{p.providerNumber}</td>
                <td>{p.contractNumber}</td>
                <td>{p.paidTo !== 'Unknown' ? p.paidTo : ''} {p.paidTo !== 'Provider' ? p.paidToName : ''}</td>
                <td><FormattedDate date={p.posted} /></td>
                <td>{p.payoutMethod}</td>
                <td style={{textAlign: "right"}}><Currency amount={p.principal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.income} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.income + p.principal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.disbursedGuaranteedPrincipal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.disbursedGuaranteedIncome} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.disbursedNonGuaranteedPrincipal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.disbursedNonGuaranteedIncome} /></td>
                <td style={{textAlign: "right"}}><Currency amount={p.disbursedGuaranteedPrincipal +
                    p.disbursedGuaranteedIncome +
                    p.disbursedNonGuaranteedPrincipal +
                    p.disbursedNonGuaranteedIncome} /></td>
            </tr>
        )
    }

    const renderDisbursementsFooterWithGuaranteed = (payouts) => {
        const principal = payouts.map(p => p.principal).reduce((a, b) => a + b);
        const income = payouts.map(p => p.income).reduce((a, b) => a + b);
        const total = payouts.map(p => p.income + p.principal).reduce((a, b) => a + b);
        const guaranteedPrincipal = payouts.map(p => p.disbursedGuaranteedPrincipal).reduce((a, b) => a + b);
        const guaranteedIncome = payouts.map(p => p.disbursedGuaranteedIncome).reduce((a, b) => a + b);
        const nonGuaranteedPrincipal = payouts.map(p => p.disbursedNonGuaranteedPrincipal).reduce((a, b) => a + b);
        const nonGuaranteedIncome = payouts.map(p => p.disbursedNonGuaranteedIncome).reduce((a, b) => a + b);
        const totalTotal = payouts.map(p => p.disbursedGuaranteedPrincipal + p.disbursedGuaranteedIncome + p.disbursedNonGuaranteedPrincipal +p.disbursedNonGuaranteedIncome).reduce((a, b) => a + b);
        
        return (
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{textAlign: "right"}}>Total</td>
                <td style={{textAlign: "right"}}><Currency amount={principal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={income} /></td>
                <td style={{textAlign: "right"}}><Currency amount={total} /></td>
                <td style={{textAlign: "right"}}><Currency amount={guaranteedPrincipal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={guaranteedIncome} /></td>
                <td style={{textAlign: "right"}}><Currency amount={nonGuaranteedPrincipal} /></td>
                <td style={{textAlign: "right"}}><Currency amount={nonGuaranteedIncome} /></td>
                <td style={{textAlign: "right"}}><Currency amount={totalTotal} /></td>
            </tr>)
    }

    const renderPurchases = (purchases) => {
        const planTotalTotal = purchases.map(p => p.netPrice).reduce((a, b) => a + b, 0);
        const amountPaidTotal = purchases.map(p => p.totalTrusted + p.totalRetained + p.disbursedGuaranteedPrincipal + p.disbursedNonGuaranteedPrincipal).reduce((a, b) => a + b, 0);
        const balanceDueTotal = purchases.map(p => (p.totalToRetain - p.totalRetained) + (p.totalToTrust - p.totalTrusted)).reduce((a, b) => a + b, 0);
        const totalTrustedTotal = purchases.map(p => p.totalTrusted).reduce((a, b) => a + b, 0);
        const totalRetainedTotal = purchases.map(p => p.totalRetained).reduce((a, b) => a + b, 0);
        const totalIncomeTotal = purchases.map(p => p.income).reduce((a, b) => a + b, 0);
        const currentValueTotal = purchases.map(p => p.totalTrusted + p.income).reduce((a, b) => a + b, 0);
        return (
            (purchases && purchases.length > 0) &&
                <div>
                    <Row className="mt-30">
                        <Col sm={6}>
                            <h4>Itemization</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Table className="table-sm dq2-table">
                                <thead>
                                    <tr>
                                        <th style={{fontWeight: "bold"}}>Provider Contract #</th>
                                        <th style={{fontWeight: "bold"}}>ClearPoint Contract #</th>
                                        <th style={{fontWeight: "bold"}}>Item Number &amp; Description</th>
                                        <th style={{fontWeight: "bold"}}>Status</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Plan Total</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Amount Paid</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Balance Due</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Total Trusted</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Total Retained</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Total Income</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Current Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {purchases.map(p => {
                                        return (
                                        <tr>
                                            <td>{p.providerNumber}</td>
                                            <td>{p.contractNumber}</td>
                                            <td>{p.itemNumber} {p.description}</td>
                                            <td>{p.currentStatus}</td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.netPrice} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalTrusted + p.totalRetained + p.disbursedGuaranteedPrincipal + p.disbursedNonGuaranteedPrincipal} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={(p.totalToRetain - p.totalRetained) + (p.totalToTrust - p.totalTrusted)} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalTrusted} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalRetained} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.income} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalTrusted + p.income} /></td>
                                        </tr>)
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}>Total</td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={planTotalTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={amountPaidTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={balanceDueTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={totalTrustedTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={totalRetainedTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={totalIncomeTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={currentValueTotal} /></td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </Col>
                    </Row>
                </div>
        )
    }

    if (combinedDetailsState.isLoading || combinedDetailsState.disbursementPayoutsLoading) {
        return <LoadingSpinner />;
    }

    const { contracts, disbursementPayoutsLoading, disbursementPayoutsAll } = combinedDetailsState;
    const purchases = contracts
        .flatMap(c => c.purchases)
        .map(p => {
            const contract = contracts.find(c => c.number === p.contractNumber);
            return { ...p, providerNumber: contract.providerNumber }
        });

    const disbursementPayouts = disbursementPayoutsAll
        .map(p => {
            const contract = contracts.find(c => c.number === p.contractNumber);
            return { ...p, providerNumber: contract.providerNumber }
        });

    const disbursementsBreakout = contracts.some(c => c.provider.disbursementsBreakout);

    return (
        <Container>
            <Row>
                <Col sm={12}>
                    <img className="logo" src="/images/ClearPoint-Logo@3x.png" alt="ClearPoint logo" />
                </Col>
            </Row>
            <Row>
                <Col sm={6} className='mt-2'>
                    <h4>Selected Contracts</h4>
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <ul>
                        {contracts.map((contract, i) => (
                            <li>
                                {contract.number}
                            </li>
                        ))}
                    </ul>
                </Col>
            </Row>
            {renderPurchases(purchases)}
                    
            { disbursementPayoutsLoading &&
                <span>loading...<img src={spinner} alt="loading ..." /></span>
            }
            {!disbursementPayoutsLoading && disbursementPayouts.length > 0 &&
                <div>
                    <Row>
                        <Col sm={6}>
                            <h4>Distributions</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Table className="table-sm dq2-table table-borderless">
                                {(!disbursementsBreakout) &&
                                    renderDisbursementsHeader()
                                }
                                {(disbursementsBreakout) &&
                                    renderDisbursementsHeaderWithGuaranteed()
                                }
                                <tbody>
                                    {disbursementPayouts.map(p => {
                                        return !disbursementsBreakout
                                        ? renderDisbursementsDetails(p)
                                        : renderDisbursementsDetailsWithGuaranteed(p)
                                    })}
                                </tbody> 
                                <tfoot>
                                    {(!disbursementsBreakout) &&
                                        renderDisbursementsFooter(disbursementPayouts)
                                    }
                                    {(disbursementsBreakout) &&
                                        renderDisbursementsFooterWithGuaranteed(disbursementPayouts)
                                    }
                                </tfoot>
                            </Table>
                        </Col>
                    </Row>
                </div>
            }
        </Container>
    )
}

export default withHeaderMessages(WithApiAccess(CombinedDetailsPrint));